export default __webpack_public_path__ + "static/media/social-icon-twitter.8a4c80e7.svg";